import { useEffect, useRef, useState } from 'react'
import { useFrame } from '@react-three/fiber'
import { useXRInputSourceState } from '@react-three/xr'

// xr-standard gamepad layout: button 4 = lower face (A/X), 5 = upper face (B/Y).
// Read the raw WebXR gamepad rather than the named 'b-button' mapping, which depends
// on the controller layout loader resolving (works in IWER, can fail on-device).
const FACE_BUTTONS = [4, 5]

export function useMenuToggle(hand: 'left' | 'right' = 'right') {
  const controller = useXRInputSourceState('controller', hand)
  const [open, setOpen] = useState(false)
  const wasPressed = useRef(false)

  useFrame(() => {
    const buttons = controller?.inputSource?.gamepad?.buttons
    const pressed = buttons != null && FACE_BUTTONS.some((i) => buttons[i]?.pressed)
    if (pressed && !wasPressed.current) setOpen((o) => !o)
    wasPressed.current = !!pressed
  })

  useEffect(() => {
    if (!import.meta.env.DEV) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key.toLowerCase() === 'm') setOpen((o) => !o)
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])

  return [open, setOpen] as const
}
